// Ensure GSAP + ScrollTrigger are available globally (enqueued via WordPress)
if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);

  document.addEventListener('DOMContentLoaded', () => {
    // ============================================================
    // Line Animation (for .line-color-block divs)
    // ============================================================
    
  });
} else {
  console.warn('GSAP or ScrollTrigger not found — make sure they’re enqueued before scripts.js');
}